<template>
  <nav
    ref="nav"
    class="nav-toc"
    @focusout="onFocusOut"
    @keydown.esc="keydownEsc"
  >
    <div class="nav-toc__header">
      <bpb-nav-toc-toggle></bpb-nav-toc-toggle>
      <slot name="heading"></slot>
    </div>
    <slot :context="context"></slot>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import { HeaderEventBus, OverlayEventBus, DialogEventBus } from '@js/eventBus';

export default {
  provide() {
    const navTocContext = {};
    Object.defineProperty(navTocContext, 'isBurger', {
      enumerable: true,
      get: () => this.isBurger,
    });
    Object.defineProperty(navTocContext, 'buttonText', {
      enumerable: true,
      get: () => this.buttonText,
    });
    Object.defineProperty(navTocContext, 'hasHeading', {
      enumerable: true,
      get: () => this.hasHeading,
    });
    Object.defineProperty(navTocContext, 'hasHeadingSize', {
      enumerable: true,
      get: () => this.hasHeadingSize,
    });

    return {
      navTocContext,
      isToc: true,
      context: this.context,
      toggle: this.toggle,
      keydownEsc: this.keydownEsc,
      registerToggleEl: this.registerToggleEl,
    };
  },
  data() {
    return {
      overwriteOverlayOnce: false,
      context: {
        isExpanded: false,
      },
      toggleEl: undefined,
      // buttonText: '',
      hasHeading: false,
      hasHeadingSize: false,
    };
  },
  computed: {
    ...mapGetters({
      breakpointDown: 'window/breakpointDown',
    }),
    isBurger() {
      return this.breakpointDown('xl');
    },
  },
  watch: {
    'context.isExpanded'(isExpanded) {
      this.$store.dispatch('overlay/set', {
        isVisible: this.overwriteOverlayOnce ? true : isExpanded,
        triggerName: this.$options._componentTag,
      });

      this.overwriteOverlayOnce = false;

      if (!isExpanded) return;
      HeaderEventBus.$emit('dossier-opened');
    },
  },
  mounted() {
    OverlayEventBus.$on('overlay-clicked', this.collapseWithOverlay);
    HeaderEventBus.$on('search-opened', this.collapse);
    HeaderEventBus.$on('dropdown-opened', this.collapse);
    HeaderEventBus.$on('burger-opened', this.collapse);
    DialogEventBus.$on('dialog-opened', this.collapse);

    const navElement = this.$el.closest('.nav-toc') || this.$el;
    const navAttr = navElement.getAttribute('buttonText');
    if (navAttr) {
      this.buttonText = navAttr;
    }
    const heading = document.querySelector('.nav-toc__heading');
    heading ? (this.hasHeading = true) : (this.hasHeading = false);

    const navSizeAttr = navElement.getAttribute('hasHeadingSize');
    if (navSizeAttr) {
      this.hasHeadingSize = navSizeAttr;
    }
  },
  beforeDestroy() {
    OverlayEventBus.$off('overlay-clicked', this.collapseWithOverlay);
    HeaderEventBus.$off('search-opened', this.collapse);
    HeaderEventBus.$off('dropdown-opened', this.collapse);
    HeaderEventBus.$off('burger-opened', this.collapse);
    DialogEventBus.$off('dialog-opened', this.collapse);
  },
  methods: {
    toggle() {
      this.context.isExpanded = !this.context.isExpanded;
    },
    collapseWithOverlay() {
      this.context.isExpanded = false;
    },
    collapse() {
      this.context.isExpanded = false;
      this.overwriteOverlayOnce = true;
    },
    registerToggleEl(el) {
      this.toggleEl = el;
    },
    keydownEsc() {
      this.context.isExpanded = false;
      this.toggleEl.focus();
    },
    onFocusOut(e) {
      if (!this.$refs.nav.contains(e.relatedTarget) && e.relatedTarget !== null)
        this.collapseWithOverlay();
    },
  },
};
</script>
